export default __webpack_public_path__ + "static/media/maleIcon.603229ae.svg";